{
  "AUTOMATION": {
    "HEADER": "Automatisations",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Ajouter une règle d'automatisation",
    "LOADING": "Récupération des règles d'automatisation",
    "ADD": {
      "TITLE": "Ajouter une règle d'automatisation",
      "SUBMIT": "Créer",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "FORM": {
        "NAME": {
          "LABEL": "Nom de la règle",
          "PLACEHOLDER": "Entrez le nom de la règle",
          "ERROR": "Le nom est requis"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Entrez la description de la règle",
          "ERROR": "La description est requise"
        },
        "EVENT": {
          "LABEL": "Événement",
          "PLACEHOLDER": "Veuillez en sélectionner un",
          "ERROR": "L'événement est requis"
        },
        "PHASE": {
          "LABEL": "Phase"
        },
        "ORDER": {
          "LABEL": "Ordre",
          "ERROR": "L'ordre est requis"
        },
        "CONDITIONS": {
          "LABEL": "Condition"
        },
        "ACTIONS": {
          "LABEL": "Actions"
        }
      },
      "CONDITION_BUTTON_LABEL": "Ajouter une condition",
      "ACTION_BUTTON_LABEL": "Ajouter une action",
      "API": {
        "SUCCESS_MESSAGE": "Règle d'automatisation ajoutée avec succès",
        "ERROR_MESSAGE": "Impossible de créer une règle d'automatisation, veuillez réessayer plus tard"
      }
    },
    "LIST": {
      "404": "Aucune règle d'automatisation trouvée",
      "TABLE_HEADER": {
        "PHASE": "Phase",
        "ORDER": "Ordre",
        "NAME": "Nom",
        "DESCRIPTION": "Description",
        "ACTIVE": "Actif",
        "CREATED_ON": "Créé le",
        "WAIT": "Délai"
      },
      "TABS": {
        "ALL": "Toutes",
        "INSTANT": "À l'événement",
        "DELAYED": "Différées"
      },
      "WAITS": "Attend {duration}"
    },
    "DELETE": {
      "TITLE": "Supprimer la règle d'automatisation",
      "SUBMIT": "Supprimer",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "CONFIRM": {
        "TITLE": "Confirmer la suppression",
        "MESSAGE": "Êtes-vous sûr de vouloir supprimer ",
        "YES": "Oui, supprimer ",
        "NO": "Non, Conserver "
      },
      "API": {
        "SUCCESS_MESSAGE": "Intégration supprimée avec succès",
        "ERROR_MESSAGE": "Impossible de créer une règle d'automatisation, veuillez réessayer plus tard"
      }
    },
    "EDIT": {
      "TITLE": "Modifier la règle d'automatisation",
      "SUBMIT": "Mettre à jour",
      "CANCEL_BUTTON_TEXT": "Annuler",
      "API": {
        "SUCCESS_MESSAGE": "Règle d'automatisation mise à jour avec succès",
        "ERROR_MESSAGE": "Impossible de mettre à jour la règle d'automatisation, veuillez réessayer plus tard"
      }
    },
    "CLONE": {
      "TOOLTIP": "Cloner",
      "API": {
        "SUCCESS_MESSAGE": "Automation clonée avec succès",
        "ERROR_MESSAGE": "Impossible de cloner la règle d'automatisation, veuillez réessayer plus tard"
      }
    },
    "FORM": {
      "EDIT": "Modifier",
      "CREATE": "Créer",
      "DELETE": "Supprimer",
      "CANCEL": "Annuler",
      "RESET_MESSAGE": "Changer le type d'événement réinitialisera les conditions et les événements que vous avez ajoutés ci-dessous"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Vous devez avoir au moins une condition pour enregistrer",
      "CONTACT_CUSTOM_ATTR_LABEL": "Attributs personnalisés des contacts",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Attributs personnalisés de la conversation"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Vous devez avoir au moins une action pour enregistrer",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Saisissez votre message ici",
      "TEAM_DROPDOWN_PLACEHOLDER": "Sélectionner une équipe",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Sélectionnez la boîte e-mail et l'adresse d'expédition",
      "SUBJECT_INPUT_PLACEHOLDER": "Objet de l'e-mail",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Sélectionnez la boîte de réception SMS d'envoi",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Saisissez le texte du SMS",
      "SMS_COUNTER": "{length}/{limit} caractères, {segments} SMS (avant le remplacement des variables)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activer la règle d'automatisation",
      "DEACTIVATION_TITLE": "Activer la règle d'automatisation",
      "ACTIVATION_DESCRIPTION": "Cette action activera la règle d'automatisation '{automationName}'. Êtes-vous sur de vouloir continuer?",
      "DEACTIVATION_DESCRIPTION": "Cette action activera la règle d'automatisation '{automationName}'. Êtes-vous sur de vouloir continuer?",
      "ACTIVATION_SUCCESFUL": "Règle d'automatisation activée avec succès",
      "DEACTIVATION_SUCCESFUL": "Règle d'automatisation désactivée avec succès",
      "ACTIVATION_ERROR": "Impossible d'activer l'automatisation, veuillez réessayer plus tard",
      "DEACTIVATION_ERROR": "Impossible de désactiver l'automatisation, veuillez réessayer plus tard",
      "CONFIRMATION_LABEL": "Oui",
      "CANCEL_LABEL": "Non"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Impossible d'envoyer la pièce jointe, veuillez réessayer",
      "LABEL_IDLE": "Charger une pièce jointe",
      "LABEL_UPLOADING": "Téléversement...",
      "LABEL_UPLOADED": "Téléchargé avec succès",
      "LABEL_UPLOAD_FAILED": "Échec de l'envoi"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "La valeur est requise",
      "VALUE_MUST_BE_BETWEEN_0_AND_998": "La valeur doit être comprise entre 0 et 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required",
      "ORDER_REQUIRED": "L'ordre est requis",
      "ORDER_MUST_BE_AT_LEAST_ONE": "L'ordre doit être au moins 1"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Cette action ne fonctionne que lorsque la phase de la règle est définie sur « Avant étiquetage ».",
      "SKIP_AUTO_LABELING": "Cette action ne fonctionne que lorsque la phase de la règle est définie sur « Avant étiquetage ».",
      "MOVE_CONVERSATION_TO_INBOX": "Seules les conversations e-mail et de chat web peuvent être déplacées vers une boîte de réception e-mail, un chat web uniquement si le contact a une adresse e-mail. Sinon, la conversation n'est pas déplacée et une note privée est ajoutée à la place.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Démarre une nouvelle conversation avec le contact dans la boîte de réception e-mail sélectionnée, lui envoie le message par e-mail et résout la conversation. Cela se produit à chaque exécution de la règle. Si le contact n'a pas d'adresse e-mail, rien n'est envoyé et une note privée est ajoutée à la place.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Démarre une nouvelle conversation avec le contact dans la boîte de réception SMS sélectionnée, lui envoie le message par SMS et résout la conversation. Cela se produit à chaque exécution de la règle. Le message est en texte brut, sans pièces jointes. Si le contact n'a pas de numéro de téléphone, rien n'est envoyé et une note privée est ajoutée à la place."
    },
    "NOTICES": {
      "AI_PROMPT": "Chaque évaluation individuelle est facturée.",
      "INCOMING_MESSAGES_COUNT": "Cela fait référence au nombre de messages entrants dans la conversation.",
      "OUTGOING_MESSAGES_COUNT": "Cela fait référence au nombre de messages sortants dans la conversation."
    },
    "PHASE": {
      "BEFORE_LABELING": "Avant étiquetage",
      "AFTER_LABELING": "Après étiquetage"
    },
    "NONE_OPTION": "Aucun",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Message entrant",
      "OUTGOING": "Message sortant",
      "PRIVATE": "Note privée",
      "AI_SUMMARY": "Résumé IA"
    },
    "YES_NO_VALUES": {
      "YES": "Oui",
      "NO": "Non"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Message direct Instagram",
      "FACEBOOK_COMMENT": "Commentaire Facebook"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Conversation créée",
      "CONVERSATION_UPDATED": "Conversation mise à jour",
      "MESSAGE_CREATED": "Message créé",
      "CONVERSATION_OPENED": "Conversation ouverte",
      "CONVERSATION_RESOLVED": "Conversation résolue",
      "PHONE_CALL_FINISHED": "Appel terminé"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Assigner à un agent",
      "ASSIGN_TEAM": "Assigner à une équipe",
      "ADD_LABEL": "Ajouter une étiquette",
      "REMOVE_LABEL": "Supprimer une étiquette",
      "SEND_EMAIL_TO_TEAM": "Envoyer un e-mail à l'équipe",
      "SEND_EMAIL_TRANSCRIPT": "Envoyer une transcription par e-mail",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Envoyer une transcription détaillée par e-mail",
      "MUTE_CONVERSATION": "Mettre la conversation en sourdine",
      "SNOOZE_CONVERSATION": "Reporter la conversation",
      "RESOLVE_CONVERSATION": "Résoudre la conversation",
      "OPEN_CONVERSATION": "Ouvrir la conversation",
      "SEND_WEBHOOK_EVENT": "Envoyer un événement webhook",
      "SEND_ATTACHMENT": "Envoyer une pièce jointe",
      "SEND_MESSAGE": "Envoyer un message",
      "ADD_NOTE": "Ajouter une note",
      "CHANGE_PRIORITY": "Changer la priorité",
      "ADD_SLA": "Ajouter un SLA",
      "SKIP_AUTO_PRIORITY": "Ignorer la priorité automatique",
      "SKIP_AUTO_LABELING": "Ignorer l'étiquetage automatique",
      "AUTO_TRANSLATE": "Traduire le message",
      "AUTO_TRANSLATE_CONVERSATION": "Traduire la conversation",
      "MOVE_CONVERSATION_TO_INBOX": "Déplacer la conversation vers une boîte de réception",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Envoyer un message dans une nouvelle conversation",
      "SEND_SMS_IN_NEW_CONVERSATION": "Envoyer un SMS dans une nouvelle conversation",
      "STOP_PROCESSING_RULES": "Arrêter le traitement des règles"
    },
    "ATTRIBUTES": {
      "EXTENSION": "Extension appelée",
      "AI_FILTER": "Filtre IA",
      "MESSAGE_TYPE": "Type de message",
      "MESSAGE_CONTAINS": "Contenu du message",
      "EMAIL": "E-mail du contact",
      "INBOX": "Boîte de réception",
      "CHANNEL_TYPE": "Type de boîte de réception",
      "CONVERSATION_LANGUAGE": "Langue de la conversation",
      "PHONE_NUMBER": "Numéro de téléphone",
      "STATUS": "Statut",
      "BROWSER_LANGUAGE": "Langue du navigateur",
      "MAIL_SUBJECT": "Objet de l'e-mail",
      "COUNTRY_NAME": "Pays",
      "MARKETPLACE_COUNTRY": "Pays de la marketplace",
      "REFERER_LINK": "Lien de provenance",
      "ASSIGNEE_NAME": "Assigné à",
      "TEAM_NAME": "Équipe",
      "PRIORITY": "Priorité",
      "CALL_DIRECTION": "Direction de l'appel",
      "MISSED_CALL": "Appel manqué",
      "MISSED_CALL_COUNT": "Nombre d'appels manqués",
      "MESSAGE_SOURCE_TYPE": "Type de source du message",
      "INCOMING_MESSAGE_COUNT": "Nombre de messages entrants",
      "OUTGOING_MESSAGE_COUNT": "Nombre de messages sortants",
      "LABEL": "Étiquette",
      "EMAIL_RECIPIENTS": "Destinataire de l'e-mail",
      "EMAIL_AUTO_REPLY": "L'e-mail est une réponse automatique",
      "ATTACHMENT_EXTENSION": "Extension de la pièce jointe",
      "WORKING_HOURS": "Pendant les heures d'ouverture",
      "AGENT_REPLIED": "Un agent a répondu depuis le changement de statut"
    },
    "WAIT": {
      "RUN_LABEL": "Exécuter les actions",
      "INSTANT": "À l'événement",
      "DELAYED": "Différé",
      "TRIGGER_LABEL": "Attendre que",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Une conversation reste dans un statut",
        "CUSTOMER_UNRESPONSIVE": "Le client ne répond pas à un agent",
        "AGENT_UNRESPONSIVE": "Le client n'obtient pas de réponse d'un agent"
      },
      "STATUS_LABEL": "Statut",
      "STATUSES": {
        "OPEN": "Ouverte",
        "PENDING": "En attente",
        "SNOOZED": "Reportée",
        "RESOLVED": "Résolue"
      },
      "DELAY_LABEL": "Délai",
      "DELAY_ERROR": "Saisissez un délai entre 1 minute et 30 jours",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} j"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Les actions s'exécutent lorsqu'une conversation est au statut {status} depuis {duration}. Un changement de statut avant les annule. Les étiquettes, les heures d'ouverture et les réponses de l'agent sont vérifiées à la fin de l'attente.",
        "CUSTOMER_UNRESPONSIVE": "Les actions s'exécutent lorsque le client n'a pas répondu depuis {duration} au message d'un agent. Une réponse du client les annule ; un nouveau message de l'agent relance l'attente.",
        "AGENT_UNRESPONSIVE": "Les actions s'exécutent lorsque le client attend depuis {duration} sans réponse d'un agent. Une réponse de l'agent les annule."
      }
    }
  }
}
